var SENTRY_RELEASE;SENTRY_RELEASE={name: "Foresight Platform", version: "1.0.0"};